export { default } from './AuditRecordDetail';
